module.exports = __webpack_public_path__ + "static/media/img1-2.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/limon/nutricheck_foliar/P/img1-2.png
// module id = 1674
// module chunks = 3